import React from 'react';

export interface InvoicePaymentReviewItem {
    invoice_number: string;
    balance: string;
    date?: string;
    due_date?: string;
}

interface InvoicePaymentReviewModalProps {
    isOpen: boolean;
    items: InvoicePaymentReviewItem[];
    totalLabel: string;
    processing?: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const InvoicePaymentReviewModal: React.FC<InvoicePaymentReviewModalProps> = ({
    isOpen,
    items,
    totalLabel,
    processing = false,
    onClose,
    onConfirm,
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div
            className="modal fade show d-block invoice-payment-review-modal"
            role="dialog"
            aria-modal="true"
        >
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <div>
                            <h5 className="modal-title mb-1">Review Invoice Payment</h5>
                            <p className="text-muted mb-0 small">Confirm the invoices to include before creating the payment order.</p>
                        </div>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={onClose}
                            disabled={processing}
                        />
                    </div>
                    <div className="modal-body">
                        <div className="list-group">
                            {items.map((item) => (
                                <div
                                    key={item.invoice_number}
                                    className="list-group-item d-flex justify-content-between align-items-start gap-3"
                                >
                                    <div>
                                        <div className="fw-semibold">Invoice #{item.invoice_number}</div>
                                        <div className="text-muted small">
                                            Issued {item.date || '-'}
                                            {item.due_date ? ` • Due ${item.due_date}` : ''}
                                        </div>
                                    </div>
                                    <div className="fw-semibold">{item.balance}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="modal-footer d-flex justify-content-between align-items-center">
                        <div className="fw-semibold">
                            Total: <span className="text-success">{totalLabel}</span>
                        </div>
                        <div className="d-flex gap-2">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={onClose}
                                disabled={processing}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={onConfirm}
                                disabled={processing || items.length === 0}
                            >
                                <i className={`fas ${processing ? 'fa-spinner fa-spin' : 'fa-credit-card'} me-2`}></i>
                                {processing ? 'Creating Order...' : 'Create Payment Order'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoicePaymentReviewModal;
